module.exports = __webpack_public_path__ + "img/arrowLeft.c83e0747.svg";